import { render, staticRenderFns } from "./UserAvatarPicker.vue?vue&type=template&id=539d9e08&scoped=true"
import script from "./UserAvatarPicker.vue?vue&type=script&lang=js"
export * from "./UserAvatarPicker.vue?vue&type=script&lang=js"
import style0 from "./UserAvatarPicker.vue?vue&type=style&index=0&id=539d9e08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539d9e08",
  null
  
)

export default component.exports